module.exports = __webpack_public_path__ + "OpenSans-ExtraBoldItalic.60d7abe173fb894cf286.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-ExtraBoldItalic.woff2
// module id = ../../../../../src/assets/customfonts/OpenSans-ExtraBoldItalic.woff2
// module chunks = styles